import { Link } from "react-router-dom";
import { BUSINESS, SOCIAL } from "../../data/content";

export const Footer = () => (
  <footer className="bg-ink text-cream py-16" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-6 grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
      <div>
        <p className="font-display text-2xl">Deaf Education Consulting LLC</p>
        <p className="mt-3 text-cream/85 max-w-sm">Support for Deaf and Hard of Hearing students, and for the schools, families and professionals around them.</p>
        <p className="lbl mt-6 text-sky">Licensed in Pennsylvania · Worldwide</p>
      </div>
      <nav aria-label="Footer">
        <p className="lbl text-sky">Explore</p>
        <ul className="mt-4 space-y-2 font-sans text-[15px]">
          {[["/services", "Services"], ["/speaking", "Speaking"], ["/resources", "Resources"], ["/about", "About Michelle"], ["/faq", "FAQ"], ["/book", "Book an appointment"], ["/contact#quote", "Request a quote"]].map(([to, label]) => (
            <li key={to}><Link to={to} className="link-u" data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}>{label}</Link></li>
          ))}
        </ul>
      </nav>
      <div>
        <p className="lbl text-sky">Contact</p>
        <ul className="mt-4 space-y-2 font-sans text-[15px] text-cream/85">
          <li><a href={`mailto:${BUSINESS.email}`} className="link-u break-all" data-testid="footer-email">{BUSINESS.email}</a></li>
          <li><a href={`tel:+1${BUSINESS.phone.replace(/\D/g, "")}`} className="link-u" data-testid="footer-phone">{BUSINESS.phone}</a></li>
          <li>In person or virtual</li>
        </ul>
        <ul className="mt-4 flex gap-3" aria-label="Social media">
          {SOCIAL.map((s) => (
            <li key={s.label}><a href={s.url} target="_blank" rel="noreferrer" className="inline-flex items-center rounded-full border border-cream/40 px-4 py-1.5 font-sans text-sm hover:bg-cream hover:text-ink transition-colors" data-testid={`footer-social-${s.label.toLowerCase()}`}>{s.label}</a></li>
          ))}
        </ul>
        <Link to="/contact#consultation" className="mt-6 inline-flex bg-paper text-ink rounded-full px-5 py-2.5 font-sans hover:bg-sky transition-colors" data-testid="footer-consultation-cta">
          Request a consultation
        </Link>
      </div>
    </div>
    <div className="max-w-6xl mx-auto px-6 mt-12 pt-6 border-t border-cream/20 flex flex-wrap justify-between gap-3 font-sans text-sm text-cream/75">
      <span>© {new Date().getFullYear()} {BUSINESS.name}</span>
      <Link to="/admin" className="link-u" data-testid="footer-admin-link">Owner sign in</Link>
    </div>
  </footer>
);
